import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import "../../styles/pt/pt-trials.css";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
import HelmetWrapper from "../../HelmetWrapper";
import PTTrackStructure from "../../components/pt-trials/PTTrackStructure";
import Notifications from "../../components/push-notifications/Notifications";

const PTTrackOpenForm = () => {
  const navigate = useNavigate();
  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};
  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  // const location = useLocation();
  // const { decryptedText, isCustom } = location.state || {};
  // useEffect(() => {
  //   if (!decryptedText) {
  //     navigate("/open-access");
  //   }
  // }, [decryptedText]);

  return (
    <HelmetWrapper title="WTF: PT Track Form Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}

        <Row>
          <Col>
            <WelcomeUser userName={userInfoData?.name} />
            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </Col>
        </Row>

        <PTTrackStructure
          decryptedText={userInfoData}
          isOpenAccessible={isCustom}
        />
      </Container>
    </HelmetWrapper>
  );
};

export default PTTrackOpenForm;
